import { AppAction, BaseAsyncReducerState } from "../../types";
import defaultAsyncReducer from "../../defaultReducer";
import { GET_AMP_STATUS } from "../../actionTypes/actionsTypes";

export interface AmpStatusState extends BaseAsyncReducerState {
    message: string
}

const initialState: AmpStatusState = {
    message: "",
    loading: false,
    error: false
}

export function getAmpStatusReducer(state = initialState, action: AppAction){
    return defaultAsyncReducer(state,action, GET_AMP_STATUS)
}